/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_Formatting_SuccessInputs */

const en_clear_formatting_success = /** @type {(inputs: Clear_Formatting_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear formatting completed successfully`)
};

const fr_clear_formatting_success = /** @type {(inputs: Clear_Formatting_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacement de la mise en forme terminé avec succès`)
};

const de_clear_formatting_success = /** @type {(inputs: Clear_Formatting_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatierung erfolgreich abgeschlossen`)
};

const it_clear_formatting_success = /** @type {(inputs: Clear_Formatting_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellazione formattazione completata con successo`)
};

const ru_clear_formatting_success = /** @type {(inputs: Clear_Formatting_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить форматирование успешно завершено`)
};

const es_clear_formatting_success = /** @type {(inputs: Clear_Formatting_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar formato completado exitosamente`)
};

const zh_cn2_clear_formatting_success = /** @type {(inputs: Clear_Formatting_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`格式化已成功完成`)
};

const ja_clear_formatting_success = /** @type {(inputs: Clear_Formatting_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォーマットのクリアが正常に完了しました`)
};

const hi_clear_formatting_success = /** @type {(inputs: Clear_Formatting_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पष्ट फ़ॉर्मेटिंग सफलतापूर्वक पूरी हो गई`)
};

const pt_pt2_clear_formatting_success = /** @type {(inputs: Clear_Formatting_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação clara concluída com sucesso`)
};

/**
* | output |
* | --- |
* | "Clear formatting completed successfully" |
*
* @param {Clear_Formatting_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const clear_formatting_success = /** @type {((inputs?: Clear_Formatting_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Formatting_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_clear_formatting_success(inputs)
	if (locale === "de") return de_clear_formatting_success(inputs)
	if (locale === "it") return it_clear_formatting_success(inputs)
	if (locale === "ru") return ru_clear_formatting_success(inputs)
	if (locale === "es") return es_clear_formatting_success(inputs)
	if (locale === "zh-CN") return zh_cn2_clear_formatting_success(inputs)
	if (locale === "ja") return ja_clear_formatting_success(inputs)
	if (locale === "hi") return hi_clear_formatting_success(inputs)
	if (locale === "pt-PT") return pt_pt2_clear_formatting_success(inputs)
	return en_clear_formatting_success(inputs)
});